import axios from "axios";
import { cache } from "../../../utils";
import { User } from "../../../stores/useUserStore";

// ---- Fetch mobile networks of countries
export const fetchMobileNetworks = async (currencyCode: string, iso2: string) => {
  const user = cache.get("USER") as User | null;
  const token = user?.token;
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/transaction/MOBILE_MONEY/providers?currency=${currencyCode}&iso2=${iso2}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data && response.data.success && Array.isArray(response.data.data)) {
      return response.data.data.map((provider: any) => ({
        code: provider.code,
        name: provider.name,
        logo: provider.logo,
        hasGateway: provider.hasGateway,
        
      }));
    }
    throw new Error("Invalid network data format");
  } catch (error) {
    console.error("Failed to fetch mobile networks:", error);
    throw error;
  }
};

// ---- Fetch Nigerian Banks
export const fetchBanks = async (currencyCode: string) => {
  const user = cache.get("USER") as User | null;
  const token = user?.token;
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/transaction/BANK_TRANSFER/providers?currency=${currencyCode}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data && response.data.success && Array.isArray(response.data.data)) {
      return response.data.data.map((bank: any) => ({
        code: bank.bankCode,
        name: bank.name,
      }));
    }
    throw new Error("Invalid bank data format");
  } catch (error) {
    console.error("Failed to fetch banks:", error);
    throw error;
  }
};